import { Palette, SemanticColors } from "@amx/ux-twoui-theming";
import { ISemanticColors } from "@fluentui/react";
import { IconList } from "../../src/components/Icon/Icon.types";

export type IconName = keyof typeof IconList;

/**
 * Combination of Icon sizes and Backplate sizes.
 * Key: Icon size.
 * Value: Backplate size which is x1.81 of Icon size.
 */
export const mapIconBackplateSize = {
    "6px": "12px",
    "8px": "14px",
    "10px": "16px",
    "12px": "20px",
    "14px": "24px",
    "16px": "32px",
    "20px": "36px",
    "24px": "40px",
    "28px": "48px",
    "32px": "60px",
    "40px": "72px",
    "48px": "96px",
    "60px": "110px",
    "72px": "132px",
    "96px": "164px",
    "164px": "294px",
    "200px": "368px"
} as const;

/**
 * Array of `IconSize` values. The typecast to specific values is intentional, as Object.keys() purposefully
 * returns just string[]. See https://github.com/Microsoft/TypeScript/pull/12253#issuecomment-263132208
 */
export const iconSizes = Object.keys(mapIconBackplateSize) as ReadonlyArray<keyof typeof mapIconBackplateSize>;

/** Type of `IconSize` variation */
export type IconSize = typeof iconSizes[number];

/** Array of `IconBackplateSize` values */
export const backplateSizes = Object.values(mapIconBackplateSize);

/** Type of `IconBackplateSize` variation */
export type IconBackplateSize = typeof backplateSizes[number];

/** Array of `IconColor` values */
export const iconColors = [
    "highlighter",
    "black",
    "white",
    "teal",
    "neutralDark",
    "neutralLight",
    "neutralLighter",
    "neutralPrimary",
    "neutralSecondary",
    "neutralTertiaryAlt",
    "themeDark",
    "themeDarker",
    "themeDarkAlt",
    "themeTertiary",
    "themeSecondary",
    "themePrimary",
    "themeLighter",
    "successIcon",
    "errorIcon",
    "warningIcon",
    "severeWarningIcon"
] as const;

/** Type of `IconColor` variation */
export type IconColor = typeof iconColors[number] | keyof Palette | keyof ISemanticColors | keyof SemanticColors;
